import { Grid } from "@mui/material";
import { useSnackbar } from "notistack";

// import { AptosSection } from "./AptosSection";
import { CloseSVG } from "../../../assets";
import { Modal, Separator, SnackMessage, Text } from "../../../components";
import { AptosWalletId } from "../../../hooks/utils/useSupportedWalletsMap";
import "./ConnectWalletModal.scss";
import { CosmosSection } from "./CosmosSection";
import { EvmSection } from "./EvmSection";
import { SolanaSection } from "./SolanaSection";

interface Props {
  isOpen: boolean;
  onCloseClick: () => void;
  setSelectedEvmWallet: (name: string | null) => void;
  setSelectedCosmosWallet: (name: string | null) => void;
  setSelectedSolanaWallet: (id: string | null) => void;
  setSelectedAptosWallet: (id: AptosWalletId | null) => void;
}

export const ConnectWalletModal = (props: Props) => {
  const { enqueueSnackbar } = useSnackbar();

  const clearWalletsCache = () => {
    localStorage.removeItem("lastCosmosConnector");
    localStorage.removeItem("lastEvmConnector");
    localStorage.removeItem("walletconnect");
    localStorage.removeItem("walletConnect_keplr");
    localStorage.removeItem("lastSolanaConnector");
    enqueueSnackbar(
      <SnackMessage
        message={{
          text: "Wallets cache cleared!",
          variant: "success",
        }}
      />,
    );
    props.onCloseClick();
  };

  return props.isOpen ? (
    <Modal
      id="connect-wallet__picker-modal"
      onCloseClick={() => props.onCloseClick()}
      className="connect-wallet-modal"
    >
      <div className="connect-wallet-modal__header">
        <div className="connect-wallet-modal__header-title">Select wallet</div>
        <CloseSVG
          className="connect-wallet-modal__header-x"
          onClick={() => props.onCloseClick()}
        />
      </div>
      <Separator className="connect-wallet-modal__separator" />

      <Grid className="connect-wallet-modal__options-grid" container>
        <EvmSection
          setSelectedEvmWallet={props.setSelectedEvmWallet}
          onCloseClick={props.onCloseClick}
        />
      </Grid>

      <Separator className="connect-wallet-modal__separator" />

      <Grid className="connect-wallet-modal__options-grid" container>
        <SolanaSection
          setSelectedSolanaWallet={props.setSelectedSolanaWallet}
          onCloseClick={props.onCloseClick}
        />
      </Grid>

      <Separator className="connect-wallet-modal__separator" />

      <Grid className="connect-wallet-modal__options-grid" container>
        <CosmosSection
          setSelectedCosmosWallet={props.setSelectedCosmosWallet}
          onCloseClick={props.onCloseClick}
        />
      </Grid>

      {/* TODO add it back when the rest is ready   */}
      {/* <Separator className="connect-wallet-modal__separator" />
      <SmallTitle primary text="Aptos"></SmallTitle>
      <Grid className="connect-wallet-modal__options-grid" container>
        <AptosSection
          setSelectedAptosWallet={props.setSelectedAptosWallet}
          onCloseClick={props.onCloseClick}
        />
      </Grid> */}

      <Separator className="connect-wallet-modal__separator" />
      <Grid justifyContent="flex-start" container>
        <Grid
          className="connect-wallet-modal__clear-wallets-cache"
          item
          onClick={clearWalletsCache}
        >
          <Text
            className="connect-wallet-modal__clear-wallets-cache-text"
            text={`Clear wallets cache`}
          />
        </Grid>
      </Grid>
    </Modal>
  ) : (
    <></>
  );
};
